export default __webpack_public_path__ + "static/media/haut.e31f9ae0.png";